/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Box, Breadcrumbs, Link, Typography, IconButton, useTheme, useMediaQuery } from "@mui/material"
import useBreadcrumbs from "use-react-router-breadcrumbs"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { ColorModeContext } from "../../theme"
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined"
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined"
import MenuIcon from "@mui/icons-material/Menu"
import LogoutIcon from '@mui/icons-material/Logout'
import { auth } from '../../firebase'
import { routes } from "../../routes"
import { useAuthState } from '../hooks/useAuthState'

type TopbarProps = {
  onMenuClick?: () => void
}

const Topbar = ({ onMenuClick }: TopbarProps) => {
  const theme = useTheme()
  const colorMode = useContext(ColorModeContext)
  const breadcrumbs = useBreadcrumbs(routes, { disableDefaults: true })
  const navigate = useNavigate()
  const { isSignedIn } = useAuthState()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const signOut = () => {
    auth.signOut()
    navigate('/', { replace: true })
  }

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" p={1}>
      <Box display="flex" alignItems="center" gap={1}>
        {/* モバイル用ハンバーガーメニュー */}
        {isMobile && isSignedIn && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuClick}
            sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Breadcrumbs aria-label="breadcrumb" sx={{ ml: isMobile ? 0 : 2 }}>
          {
            breadcrumbs.map(({ breadcrumb, key }, i) => (
              breadcrumbs.length === i + 1 ?
                <Typography key={key} variant={isMobile ? "body1" : "h6"}>{breadcrumb}</Typography> :
                <Link
                  key={key}
                  underline="hover"
                  color="blue"
                  onClick={() => navigate(key)}
                  sx={{ cursor: 'pointer' }}
                >
                  <Typography variant={isMobile ? "body2" : "h6"}>{breadcrumb}</Typography>
                </Link>
            ))
          }
        </Breadcrumbs>
      </Box>
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        {isSignedIn &&
          <IconButton onClick={signOut}>
            <LogoutIcon />
          </IconButton>
        }
      </Box>
    </Box>
  )
}

export default Topbar
